export const stringToHsl = (value: string): string => {
    if (value === '') return '';
    let hash = 0;
    for (let i = 0; i < value.length; i++) {
        hash = (value.codePointAt(i) ?? 0) + ((hash << 5) - hash);
        hash &= hash;
    }
    return `hsl(${hash % 360}, ${60 + (hash % 10)}%,${60 + (hash % 5)}%)`;
};

export const eventCardExpanded = (eventId: string): string => `eventExpanded/${eventId}`;
